import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import React, { ReactNode } from 'react';

interface IButton {
    onClick: () => void;
    key: ReactNode | null;
    className?: string;
    style?:any
}

const AddButton = ({ onClick, className }: IButton) => {
    return (
        <Button onClick={onClick} aria-label='Add' className={className}>
            <AddIcon />
        </Button>
    );
};

const RemoveButton = ({ onClick, className }: IButton) => {
    return (
        <Button onClick={onClick} aria-label='Remove' className={className}>
            <DeleteIcon />
        </Button>
    );
};

export { AddButton, RemoveButton };
